import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import EmptyDealsBg from "../../assets/images/emptyDealsBg.png";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  emptyDeals: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    padding: "0 5rem",
    width: "100%",
    gap: ".75rem",
    height: "18.25rem",
    background: `url(${EmptyDealsBg})`,
    backgroundRepeat: "no-repeat !important",
    backgroundSize: "100% 100%",

    [theme.breakpoints.down("sm")]: {
      padding: "0 0 0 1rem",
      width: "100%",
      backgroundPosition: "50% 20%",
      justifyContent: "center",
      borderRadius: "1rem",
      height: "16rem",
    },
  },
  learnMoreBtn: {
    width: "8.75rem",
    fontSize: "0.875rem",
    height: "2.5rem",
    marginBottom: "5rem",
    marginRight: ".75rem",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "0rem",
    },
  },
  buyGainsButton: {
    backgroundColor: "transparent",
    color: "rgba(17, 48, 45, 1)",
    border: "1px solid rgba(17, 48, 45, 0.2)",
    height: "2.5rem",
    fontSize: "0.875rem",
  },
}));
export default function EmptyPools({
  setOpenBuy,
}: {
  setOpenBuy: (value: boolean) => void;
}) {
  const classes = useStyles();

  return (
    <Grid item className={classes.emptyDeals}>
      <Typography component="span" variant="h2" color="secondary">
        Upcoming IDO
      </Typography>
      <Typography>Our next launch is coming soon...</Typography>
      <Box display="flex">
        <Link to="/ido-step-by-step">
          <Button
            variant="contained"
            color="secondary"
            className={classes.learnMoreBtn}
          >
            Learn More
          </Button>
        </Link>
        <Button
          variant="contained"
          color="secondary"
          className={classes.buyGainsButton}
          onClick={() => {
            setOpenBuy(true);
          }}
        >
          Buy GAINS
        </Button>
      </Box>
    </Grid>
  );
}
